// removed by extract-text-webpack-plugin
module.exports = {"footer":"_8IhhYH8n","social-links":"_1s5or02L","socialLinks":"_1s5or02L","copyright":"_12t12iv9","ohsu-map":"_1ihwHIJT","ohsuMap":"_1ihwHIJT","bottom":"_2Okyys2D","links":"_3b9W8B5j","link":"_3r-zGzNf","made-by":"_3VZdlBoG","madeBy":"_3VZdlBoG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.pcss
// module id = 408
// module chunks = 0